import { Pipe, PipeTransform } from '@angular/core';
import { ProductOffering } from 'anchor-shared/lib/model/entity/productOffering';

@Pipe({
  name: 'activeProductOfferings',
})
export class ActiveProductOfferingsPipe implements PipeTransform {
  transform(
    array: Partial<ProductOffering>[],
    field: string,
  ): Partial<ProductOffering>[] {
    if (!Array.isArray(array)) {
      return;
    }
    array.sort((a: any, b: any) => {
      if (b[field] < a[field]) {
        return -1;
      } else if (b[field] > a[field]) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }
}
